import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { readStoredUser } from "../utils/sessionUser";
import CrmPanel from "./CrmPanel";
import Dashboard from "./pages/Dashboard";
import Contacts from "./pages/Contacts";
import ContactDetail from "./pages/ContactDetail";
import Companies from "./pages/Companies";
import Leads from "./pages/Leads";
import Opportunities from "./pages/Opportunities";
import Activity from "./pages/Activity";
import Tasks from "./pages/Tasks";
import Campaigns from "./pages/Campaigns";
import Loyalty from "./pages/Loyalty";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import OpportunityPipelineSettings from "./pages/OpportunityPipelineSettings";
import "./crm.css";

export default function CrmApp() {
  const sessionUser = readStoredUser();
  const allowedModules = Array.isArray(sessionUser?.allowed_modules)
    ? sessionUser.allowed_modules
    : [];

  if (!allowedModules.includes("crm")) {
    return <Navigate to="/select-module" replace />;
  }

  return (
    <Routes>
      <Route element={<CrmPanel />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="contacts/:id" element={<ContactDetail />} />
        <Route path="companies" element={<Companies />} />
        <Route path="leads" element={<Leads />} />
        <Route path="opportunities" element={<Opportunities />} />
        <Route path="activity" element={<Activity />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="loyalty" element={<Loyalty />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<Navigate to="/crm/settings/user-experience" replace />} />
        <Route path="settings/user-experience" element={<Settings />} />
        <Route path="settings/lead-pipelines" element={<Navigate to="/crm/settings/pipelines" replace />} />
        <Route path="settings/pipelines" element={<OpportunityPipelineSettings />} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Route>
    </Routes>
  );
}
